﻿{
  "community": {
    "name": "Społeczność",
    "shortDescription": "Pojedyncze konto z bezpłatnymi ćwiczeniami",
    "features": [
      "Wyszukuj i udostępniaj ćwiczenia",
      "Nieograniczony zbiór ćwiczeń w chmurze",
      "Dostęp do ćwiczeń Premium"
    ],
    "price": "Bezpłatnie",
    "termName": "Bez ograniczeń"
  },
  "personal": {
    "name": "Subskrypcja osobista",
    "shortDescription": "Pojedyncze konto z niestandardowymi ćwiczeniami",
    "features": [
      "Utwórz i edytuj ćwiczenia online",
      "Uwzględnia osobistą listę odtwarzania",
      "Uzyskuj dostęp do ćwiczeń w drodze"
    ]
  },
  "professional": {
    "name": "Subskrypcja profesjonalisty",
    "shortDescription": "Pojedyncze konto dla wielu uczniów",
    "features": [
      "Zarządzaj zadaniami dla uczniów",
      "Monitoruj postępy uczniów",
      "Współpracuj z członkami zespołu"
    ]
  },
  "organization": {
    "name": "Subskrypcja instytucjonalna",
    "shortDescription": "Wiele kont dla wielu uczniów",
    "features": [
      "Zarządzanie instruktorami",
      "Raporty na poziomie organizacji",
      "Ustawienia poufności w firmie"
    ],
    "price": "Kontakt z nami",
    "termName": "Okresy od 1 do 5 lat"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Podgląd edytora stacjonarnego",
    "note": "Wypróbuj <1>$t(common:action.free)</1> przez 30 dni!",
    "price": "Bezpłatnie",
    "termName": "Wersja próbna 30-dniowa",
    "footerNote": "1 instalacja"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Pełny edytor stacjonarny",
    "note": "",
    "termName": "Zakup jednorazowy",
    "footerNote": "2 instalacje na użytkownika"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Wiele licencji dla organizacji",
    "note": "",
    "price": "Kontakt z nami",
    "termName": "Obniżki dla wielu licencji",
    "footerNote": "2 instalacje na użytkownika"
  }
}
